// Mood Board Color
export const BG_PRIMARY = '#fff9f1';
export const BG_SECONDARY = '#7e1a1a';
export const BG_FOOTER = '#ffddd2';

// Text Color
export const TEXT_PRIMARY = '#1a1b1d';
export const TEXT_SECONDARY = '#7e1a1a';
export const TEXT_ALTERNATIVE = '#ffffff';

// Asset Color
export const ASSET_BACKGROUND = '#dd9582';
export const ASSET_LOVE_TITLE = '#f3beb6';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#ac7e6fff'; // Warna BG
export const ICON_NAVIGATION_COLOR = TEXT_PRIMARY; // Warna Iconnya
